// extracted by mini-css-extract-plugin
export default {"label":"Label-module__label___PaO7u","sm":"Label-module__sm___Wnu3x","lg":"Label-module__lg___mAxB8","xs":"Label-module__xs___SboV9","error":"Label-module__error___jp3Oy"};